import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Link as Link1 } from "react-scroll";
import { FaBars, FaTimes } from "react-icons/fa"; // Hamburger & Close icons
import "./Navbar.scss";
import Logo from "../../assets/icons/Logo";

import { useSelector } from "react-redux";
import { getStoreInfo } from "../../utils/utils";

export default function Navbar() {
  const [scroll, setScroll] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const reduxRestaurantInfo = useSelector((state) => state.data?.restaurantInfo);
  const storeInfo = reduxRestaurantInfo || getStoreInfo();
  const visibleSections = storeInfo?.visibleSections || {};

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const allNavItems = [
    { name: "Home", link: "home", id: "home" },
    { name: "About Us", link: "about", id: "about" },
    { name: "Menus", link: "menus", id: "menus" },
    { name: "Book a Table", link: "tables", id: "tables" },
    { name: "Contact Us", link: "contact", id: "contact" },
  ];

  const navItems = allNavItems.filter((item) => visibleSections[item.id] !== false);

  return (
    <header className={`navbar ${scroll ? "scrolled" : ""}`}>
      <div className="container container-nav">
        {/* Left: Logo */}
        <div className="navbar-left">
          <Link className="logo" to={"/"}>
            <Logo />
          </Link>
        </div>

        {/* Center: Navigation Links (Hidden in Mobile) */}
        <nav className={`navbar-center ${isMobileMenuOpen ? "open" : ""}`}>
          <ul className="navigation-menu">
            {navItems
              .filter((item) => !item.isMobileOption && !item.isExternal) // ✅ Hide Mobile-Only Items
              .map((item, index) => (
                <li key={index}>
                  <Link1
                    to={item.link}
                    spy
                    smooth
                    duration={500}
                    className="nav-item"
                  >
                    {item.name}
                  </Link1>
                </li>
              ))}
          </ul>
        </nav>

        {/* Right: Book a Demo & Login (Hidden in Mobile) */}
        <div className="navbar-right">
          {/* Hamburger Menu for Mobile */}
          <button className="hamburger-menu" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          {/* Close Button */}
          <button className="close-menu" onClick={toggleMobileMenu}>
            <FaTimes />
          </button>

          {/* Mobile Nav Links with Alternating Animations */}
          <ul>
            {navItems.map((item, index) => (
              <li
                key={index}
                className={`menu-item ${
                  index % 2 === 0 ? "slide-right" : "slide-left"
                }`}
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                {item.isExternal ? (
                  <Link to={item.link} onClick={toggleMobileMenu}>
                    {item.name}
                  </Link>
                ) : (
                  <Link1
                    to={item.link}
                    spy
                    smooth
                    duration={500}
                    onClick={toggleMobileMenu}
                  >
                    {item.name}
                  </Link1>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
